/*@ngInject*/
const ApplicationController = function ($rootScope, $scope, $state, $location, $timeout, coreConstant, localization, authorizationConstants, coreMediator, notificationPopupUtil, authenticationUtil, refreshLoginTokenUtil, uiPerformanceLogger, adminFunctionHeaderButtonsMediator, adminFunctionHeaderButtonsModel) {

    var bootstrapRedirect,
        timeoutList = [],
        notificationLoadingBarPromise = null,
        notificationLoadingBarScope = null,
        fadingNotificationScope = null;

    $scope.appIsReady = false;

    function goToLoginPage() {
        $scope.appIsReady = true;

        if ($state.current.name !== 'password' && !$location.search().token) {

            if (!bootstrapRedirect) {
                bootstrapRedirect = $location.url();

                if (_.startsWith(bootstrapRedirect, '/login') || bootstrapRedirect === '') {
                    bootstrapRedirect = null;
                }
            }

            $state.go('login', {
                username: $location.search().username,
                login: $location.search().login,
                externalToken: $location.search().externalToken
            });
        }
    }

    function bootstrapApplication(skipRedirection) {

        coreMediator.bootstrapApplication().then(function () {
            $scope.appIsReady = true;
            var tabList = [];
            if (!skipRedirection) {
                if (bootstrapRedirect) {
                    $location.url(bootstrapRedirect);
                    bootstrapRedirect = null;
                } else {
                    adminFunctionHeaderButtonsMediator.getAvailableAdminFunctions().then(function (actions) {
                        _.each(actions, function (value, key) {
                            var item = {};
                            item.name = key;
                            item.subTabs = actions[key];
                            tabList.push(item);
                        });
                        if (tabList.length > 0) {
                            var tab = tabList[0];
                            var subTabs = tab.subTabs;
                            var stateMap = adminFunctionHeaderButtonsModel.getStateMappings(tab.name, subTabs[0]);
                            $state.go(stateMap.state, stateMap.params);
                        } else {
                            $state.go('configuration.defaultHomePage');
                        }
                    });
                }
            }
        });
    }

    $scope.$on(coreConstant.event.BOOT_APPLICATION, function () {
        bootstrapApplication();
    });


    $scope.$on(coreConstant.event.INVALID_SESSION, function () {
        // Remove the login details if there was an invalid session error, as this may indicate the token has
        // expired.
        coreMediator.removeLoginToken();
        coreMediator.removeClientId();

        refreshLoginTokenUtil.stop();

        goToLoginPage();
    });

    $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION, function (event, notification) {
        timeoutList.push($timeout(function () {
            fadingNotificationScope = $rootScope.$new(true);
            fadingNotificationScope.notification = notification;
            notificationPopupUtil.displayNotificationPopup(fadingNotificationScope);
        }, 0));
    });

    $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
        notificationLoadingBarScope = $rootScope.$new(true);
        notificationLoadingBarScope.notification = notification;
        notificationLoadingBarScope.isLoadingBar = true;

        notificationLoadingBarPromise = notificationPopupUtil.displayNotificationPopup(notificationLoadingBarScope);
    });

    $scope.$on(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
        if (!_.isNil(notificationLoadingBarScope)) {
            notificationLoadingBarScope.notification = notification;
            notificationLoadingBarScope.isLoadingBar = false;
        }
    });

    $scope.$on(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, function (event, isHard) {
        if (!_.isNil(notificationLoadingBarPromise)) {
            notificationLoadingBarPromise.then(function (notification) {
                notification.kill(isHard);
            });
            notificationLoadingBarPromise = null;
        }
    });

    $scope.$on(coreConstant.event.START_UI_PERFORMANCE_LOG, function (event, logAction, message) {
        uiPerformanceLogger.startLog(logAction, message);
    });

    $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG, function (event, logAction, status, newMessage) {
        uiPerformanceLogger.endLog(logAction, status, newMessage);
    });

    $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, function (event, logAction) {
        uiPerformanceLogger.endLogWithoutLogging(logAction);
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    localization.getTranslations().then(function () {
        authenticationUtil.attemptAutoAuthentication().then(bootstrapApplication, goToLoginPage);
    });
};

angular.module('ums')
    .controller('applicationController', ApplicationController);
